import { ClickAwayListener, Grow, ListItemText, MenuItem, Popper } from '@material-ui/core';
import * as React from 'react';
import { MedicationType, prettyPrintMedicationType } from '../Contracts/MedicationModels';
import { black } from '../Styles/Colours';
import styles from './AddMedicationMenu.module.css';
import { ComplementaryTherapyIcon, MedicationHistoryIcon, MedicationOrderIcon, ReceiptIcon, TakeHomeScriptIcon } from '../Components/Icons';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { PermissionsCheck } from '../Components/Auth/PermissionsCheck';
import { usePermissions } from '../Hooks/usePermissions';
export var AddMedicationMenu = function (props) {
    var showMedicationsBrowser = function (medicationType) {
        props.onClose();
        props.canAddMedication(function () {
            props.showMedicationsBrowser(medicationType);
        });
    };
    var permissions = usePermissions({
        prescribeMedicationsTakeHomeScript: MedicationsPermissions.PrescribeMedicationsTakeHomeScript,
        prescribeMedicationsEnrmcScript: MedicationsPermissions.PrescribeMedicationsEnrmcScript,
        prescribeMedicationsMedicationOrder: MedicationsPermissions.PrescribeMedicationsMedicationOrder,
        prescribeMedicationsMedicationHistory: MedicationsPermissions.PrescribeMedicationsMedicationHistory,
        prescribeComplementaryTherapyOrder: MedicationsPermissions.PrescribeComplementaryTherapyOrder
    });
    var allowedPermissionCount = [
        permissions.prescribeMedicationsTakeHomeScript,
        permissions.prescribeMedicationsEnrmcScript,
        permissions.prescribeMedicationsMedicationOrder,
        permissions.prescribeMedicationsMedicationHistory,
        permissions.prescribeComplementaryTherapyOrder
    ].filter(Boolean).length;
    if (allowedPermissionCount == 1 && props.anchor !== null) {
        if (permissions.prescribeMedicationsTakeHomeScript) {
            showMedicationsBrowser(MedicationType.TakeHomeScript);
        }
        if (permissions.prescribeMedicationsMedicationOrder) {
            showMedicationsBrowser(MedicationType.MedicationOrder);
        }
        if (permissions.prescribeMedicationsMedicationHistory) {
            showMedicationsBrowser(MedicationType.MedicationHistory);
        }
        if (permissions.prescribeMedicationsEnrmcScript) {
            showMedicationsBrowser(MedicationType.EnrmcScript);
        }
        if (permissions.prescribeComplementaryTherapyOrder) {
            showMedicationsBrowser(MedicationType.ComplementaryTherapyOrder);
        }
    }
    return (React.createElement(Popper, { anchorEl: props.anchor, open: props.anchor !== null, placement: 'bottom-end', className: styles.popper, modifiers: {
            flip: {
                enabled: true
            },
            preventOverflow: {
                enabled: true,
                boundariesElement: 'scrollParent'
            }
        } },
        React.createElement(ClickAwayListener, { onClickAway: function () { return props.onClose(); } },
            React.createElement(Grow, { in: true, style: { transformOrigin: 'top right' } },
                React.createElement("div", { className: styles.addMenu },
                    React.createElement(PermissionsCheck, { permission: MedicationsPermissions.PrescribeMedicationsTakeHomeScript },
                        React.createElement(MenuItem, { onClick: function () { return showMedicationsBrowser(MedicationType.TakeHomeScript); }, "data-test-id": 'menuItem_AddTakeHomeScript' },
                            React.createElement("div", { className: styles.menuItem },
                                React.createElement(TakeHomeScriptIcon, { size: '24', color: black }),
                                React.createElement(ListItemText, { primary: prettyPrintMedicationType(MedicationType.TakeHomeScript) })))),
                    React.createElement(PermissionsCheck, { permission: MedicationsPermissions.PrescribeMedicationsMedicationOrder },
                        React.createElement(MenuItem, { onClick: function () { return showMedicationsBrowser(MedicationType.MedicationOrder); }, "data-test-id": 'menuItem_AddMedicationOrder' },
                            React.createElement("div", { className: styles.menuItem },
                                React.createElement(MedicationOrderIcon, { size: '24', color: black }),
                                React.createElement(ListItemText, { primary: prettyPrintMedicationType(MedicationType.MedicationOrder) })))),
                    React.createElement(PermissionsCheck, { permission: MedicationsPermissions.PrescribeMedicationsMedicationHistory },
                        React.createElement(MenuItem, { onClick: function () { return showMedicationsBrowser(MedicationType.MedicationHistory); }, "data-test-id": 'menuItem_AddMedicationHistory' },
                            React.createElement("div", { className: styles.menuItem },
                                React.createElement(MedicationHistoryIcon, { size: '24', color: black }),
                                React.createElement(ListItemText, { primary: prettyPrintMedicationType(MedicationType.MedicationHistory) })))),
                    React.createElement(PermissionsCheck, { permission: MedicationsPermissions.PrescribeMedicationsEnrmcScript },
                        React.createElement(MenuItem, { onClick: function () { return showMedicationsBrowser(MedicationType.EnrmcScript); }, "data-test-id": 'menuItem_AddEnrmcScript' },
                            React.createElement("div", { className: styles.menuItem },
                                React.createElement(ReceiptIcon, { size: '24', color: black }),
                                React.createElement(ListItemText, { primary: prettyPrintMedicationType(MedicationType.EnrmcScript) })))),
                    React.createElement(PermissionsCheck, { permission: MedicationsPermissions.PrescribeComplementaryTherapyOrder },
                        React.createElement(MenuItem, { onClick: function () { return showMedicationsBrowser(MedicationType.ComplementaryTherapyOrder); }, "data-test-id": 'menuItem_AddComplementaryTherapyOrder' },
                            React.createElement("div", { className: styles.menuItem },
                                React.createElement(ComplementaryTherapyIcon, { size: '24', color: black }),
                                React.createElement(ListItemText, { primary: prettyPrintMedicationType(MedicationType.ComplementaryTherapyOrder) })))))))));
};
